import React, { useEffect, useState } from "react";
import Layout from "./layout";
import ListOrderMasuk from "../component/ListOrderMasuk";
import ListOrderAktif from "../component/ListOrderAktif";
import ListHistoryProduk from "../component/ListHistory";
import FormAddOrder from "./petani/PetaniAddOrder";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getMe } from "../features/authSlice";
import Spinner from "react-bootstrap/Spinner";

const OrderProduct = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isError, user, isLoading } = useSelector((state) => state.auth);
  const [activeTab, setActiveTab] = useState("masukorder");

  useEffect(() => {
    if (!user) {
      dispatch(getMe());
    }
  }, [dispatch, user]);

  useEffect(() => {
    if (isError) {
      navigate("/");
    }
  }, [isError, navigate]);

  const TABS =
    user?.role === "petani"
      ? [
          { id: "addorder", label: "Add Order", component: <FormAddOrder /> },
          {
            id: "aktiforder",
            label: "Order Aktif",
            component: <ListOrderAktif />,
          },
          {
            id: "historyorder",
            label: "History Order",
            component: <ListHistoryProduk />,
          },
        ]
      : [
          {
            id: "masukorder",
            label: "Order Masuk",
            component: <ListOrderMasuk />,
          },
          {
            id: "aktiforder",
            label: "Order Aktif",
            component: <ListOrderAktif />,
          },
          {
            id: "historyorder",
            label: "History Order",
            component: <ListHistoryProduk />,
          },
        ];

  return (
    <Layout>
      {isLoading || !user ? (
        <div className="loading-spinner d-flex flex-column align-items-center justify-content-center">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
          <p>Loading...</p>
        </div>
      ) : (
        <>
          <div className="tabs">
            {TABS.map((tab) => (
              <button
                key={tab.id}
                className={`tab ${activeTab === tab.id ? "active" : ""}`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </div>
          <div className="content-tanam">
            {TABS.find((tab) => tab.id === activeTab)?.component}
          </div>
        </>
      )}
    </Layout>
  );
};

export default OrderProduct;
